import { Component, EventEmitter, Output, Input, OnChanges, SimpleChanges, ContentChild, TemplateRef, OnInit, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MAT_SELECT_CONFIG, MatSelectChange } from '@angular/material/select';
import { IOption } from '../../pages/user/components/ddl';
 

@Component({
    selector: 'curve-range',
    templateUrl: './curve-range.component.html',
    styleUrls: ['./curve-range.component.less']
})
export class CurveRangeComponent {

    @Input() value: number = 0;
    @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();
    
}
